type Props = {
  collapsed?: boolean;
};

export default function AnnouncementIcon({ collapsed }: Props) {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={collapsed ? {} : { transform: "scale(0.9)" }}
        className={collapsed ? "" : "relative left-[3px]"}
      >
        <path
          d="M12.25 5.44493V17.0435C12.25 17.167 12.2805 17.2886 12.3387 17.3974C12.397 17.5063 12.4812 17.5991 12.584 17.6676L13.6145 18.3546C13.7145 18.4213 13.829 18.4629 13.9485 18.4761C14.068 18.4892 14.1889 18.4734 14.301 18.4301C14.4131 18.3868 14.5131 18.3171 14.5927 18.227C14.6722 18.1369 14.729 18.029 14.7581 17.9125L16 12.9449M12.25 5.44493H16C16.9946 5.44493 17.9484 5.84002 18.6516 6.54328C19.3549 7.24654 19.75 8.20037 19.75 9.19493C19.75 10.1895 19.3549 11.1433 18.6516 11.8466C17.9484 12.5498 16.9946 12.9449 16 12.9449M12.25 5.44493C12.25 5.44493 7.14515 5.44493 2.23271 1.32484C2.12346 1.23288 1.99022 1.17404 1.84866 1.15522C1.70711 1.1364 1.56312 1.1584 1.43364 1.21862C1.30416 1.27884 1.19456 1.37478 1.11774 1.49515C1.04092 1.61553 1.00007 1.75534 1 1.89814V16.4917C1.00007 16.6345 1.04092 16.7743 1.11774 16.8947C1.19456 17.0151 1.30416 17.111 1.43364 17.1712C1.56312 17.2315 1.70711 17.2535 1.84866 17.2346C1.99022 17.2158 2.12346 17.157 2.23271 17.065C7.14515 12.9449 12.25 12.9449 12.25 12.9449L16 12.9449"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
